import Raven from 'raven-js';

export const BrazeCustomEvents = {
  EVENT_VISITED: 'Event Visited',
  TICKET_CLICKED: 'Ticket Clicked',
  BOOKING_STARTED: 'Booking Started',
  EVENT_SAVED: 'Event Saved',
  EVENT_UNSAVED: 'Event Unsaved',
  CATEGORY_VISITED: 'Category Visited',
  EMAIL_ADDRESS_CAPTURED: 'Email Address Captured',
  EVENT_REVIEWED: 'Event Reviewed',
  WEBSITE_CLICKED_OUT: 'Website Clicked Out',
  CHARITY_ENTRY_COMPLETED: 'Charity Entry Completed',
  GROUP_LINK_SENT_TO_PHONE: 'Group Link Sent To Phone',
  VIRTUAL_EVENT_COMPLETED: 'Virtual Event Completed',
};

export const BrazePurchaseEvents = {
  BOOKING_COMPLETED: 'Booking Completed',
};

const getAllEvents = (EventObject) => {
  return Object.values(EventObject).reduce((acc, val) => {
    acc.push(val);
    return acc;
  }, []);
};

export const changeBrazeUser = async (uniqueEmailId) => {
  appboy.changeUser(uniqueEmailId);
};

const getCurrentUser = async () => {
  let userId;
  await appboy.getUser()?.getUserId((currentUser) => {
    userId = currentUser;
  });
  return userId;
};

const setUserDataInBraze = (profile) => {
  /* eslint-disable no-unused-expressions */
  if (!profile) {
    return;
  }

  const {
    givenName,
    familyName,
    emailAddress,
    location,
    primaryIdentityId,
    phoneNumber,
  } = profile;

  if (givenName) {
    appboy.getUser()?.setFirstName(givenName);
  }
  if (familyName) {
    appboy.getUser()?.setLastName(familyName);
  }
  if (emailAddress) {
    appboy.getUser()?.setEmail(emailAddress);
  }
  if (phoneNumber) {
    appboy.getUser()?.setPhoneNumber(phoneNumber);
  }
  if (
    location &&
    location.center &&
    location.center.latitude &&
    location.center.longitude
  ) {
    appboy
      .getUser()
      ?.setLastKnownLocation(
        location.center.latitude,
        location.center.longitude,
      );
  }
  if (primaryIdentityId) {
    appboy
      .getUser()
      ?.setCustomUserAttribute('primaryIdentityId', primaryIdentityId);
  }
  /* eslint-enable no-unused-expressions */
};

export const setLastVisitedEvent = (eventId) => {
  // eslint-disable-next-line no-unused-expressions
  appboy.getUser()?.setCustomUserAttribute('Last Visited Event', eventId);
};

export const logCustomEvent = (eventType, properties) => {
  const existingEvents = getAllEvents(BrazeCustomEvents);
  if (!existingEvents.includes(eventType)) {
    Raven.captureMessage(
      `Unknown event "${eventType}" being submitted to Braze. Please add your event to the BrazeCustomEvents object`,
    );
  } else {
    appboy.logCustomEvent(eventType, properties);
  }
};

export const logPurchaseEvent = (
  eventType,
  purchaseProperties,
  customProperties,
) => {
  const existingEvents = getAllEvents(BrazePurchaseEvents);
  if (!existingEvents.includes(eventType)) {
    Raven.captureMessage(
      `Unknown purchase event "${eventType}" being submitted to Braze. Please add your event to the BrazePurchaseEvents object`,
    );
    return;
  }

  const {
    productId: uncastProductId,
    price,
    currencyCode,
    quantity,
  } = purchaseProperties;
  const productId = String(uncastProductId); // Must be string

  if (!productId || !price) {
    Raven.captureMessage(
      `Purchase event "${eventType}" is missing the following properties:${
        !productId ? ' productId' : ''
      }${!price ? ' price' : ''}. Please add these to the event.`,
    );
    return;
  }
  appboy.logPurchase(productId, price, currencyCode || 'GBP', quantity || 1, {
    ...customProperties,
    triggering_event: eventType,
  });
};

export const setupBrazeUser = async ({
  brazeUserId,
  acquisitionChannel,
  emailAddress,
  firstName,
  lastName,
  location,
  primaryIdentityId,
  phoneNumber,
  shouldResetUserOnCompletion,
  onComplete,
}) => {
  let originalUserId;
  if (shouldResetUserOnCompletion) {
    originalUserId = await getCurrentUser();
  }

  await changeBrazeUser(brazeUserId);
  setUserDataInBraze({
    givenName: firstName,
    familyName: lastName,
    emailAddress,
    location,
    primaryIdentityId,
    phoneNumber,
  });
  logCustomEvent(BrazeCustomEvents.EMAIL_ADDRESS_CAPTURED, {
    acquisitionChannel,
  });

  if (shouldResetUserOnCompletion && originalUserId) {
    await changeBrazeUser(originalUserId);
  }

  if (onComplete) {
    onComplete();
  }
};
